import { useQuery } from '@tanstack/react-query';
import { User } from '../types';

export default function useCurrentUser() {
  const { data, isLoading, refetch } = useQuery<User>({
    queryKey: ['me'],
  });

  return {
    isLoading,
    currentUser: data,
    refetch,
    isSystemAdmin: data?.userRole === 'SYSTEM_ADMIN',
    isServiceAdmin: data?.userRole === 'SERVICE_ADMIN',
    isAdmin: data?.userRole === 'SYSTEM_ADMIN' || data?.userRole === 'SERVICE_ADMIN',
    isAdvisor: data?.userRole === 'ADVISOR',
  };
}
